import { AfterViewInit, Component, Inject, OnInit, ViewChild } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { Alginment, EMPTY_STRING, LoadingMessages } from "src/app/common/Const";
import { MI200002, MQ200003 } from "src/app/common/const-message-id";
import { GC_D2087_APPROVED } from "src/app/common/ConstCcd";
import { TableColumnDef } from "src/app/common/table-column-def";
import { ReqAccess } from "src/app/request/req-access";
import { ReqSpmt10321Confirm, Spmt10321ConfirmRowDto } from "src/app/request/req-spmt10321-confirm";
import { CommonService } from "src/app/service/common.service";
import { HttpBasicService } from "src/app/service/http-basic.service";
import { MessageService } from "src/app/service/message.service";
import { NotificationDialogComponent } from "../notification-dialog/notification-dialog.component";

export enum ColumnIds {
  SlipNo = "slipNo",
  StoreCd = "storeCd",
  StoreNm = "storeNm",
  DisposalDate = "disposalDate",
  ReqStatusNm = "reqStatusNm",
  RedBlackNm = "redBlackNm",
  SlipCancelNm = "slipCancelNm",
  DtQtyTotal = "dtQtyTotal",
  CostAmtExcTotal = "costAmtExcTotal",
  SellPriceAmtExcTotal = "sellPriceAmtExcTotal",
  SlipCreateDate = "slipCreateDate",
  SlipApproveDate = "slipApproveDate",
  SlipChangeDate = "slipChangeDate",
  SlipCancelDate = "slipCancelDate",
  RequesterCd = "requesterCd",
  ApproverCd = "approverCd",
  SlipComment = "slipComment",
  ApproverComment = "approverComment",
}

export enum ColumnHeaders {
  SlipNo = "伝票番号",
  StoreCd = "店舗コード",
  StoreNm = "店舗名称",
  DisposalDate = "廃棄日",
  ReqStatusNm = "申請状態",
  RedBlackNm = "赤黒区分",
  SlipCancelNm = "伝票取消フラグ",
  DtQtyTotal = "数量合計",
  CostAmtExcTotal = "原価金額合計(抜)",
  SellPriceAmtExcTotal = "売価金額合計(抜)",
  SlipCreateDate = "伝票登録日",
  SlipApproveDate = "伝票承認日",
  SlipChangeDate = "伝票訂正日",
  SlipCancelDate = "伝票取消日",
  RequesterCd = "申請者",
  ApproverCd = "承認者",
  SlipComment = "申請者コメント",
  ApproverComment = "承認者コメント",
}

interface TableRow extends Spmt10321ConfirmRowDto {
  form: {
    approverCommentFormCtrl: FormControl;
  };
}

@Component({
  selector: "spmt10321-confirm-dialog",
  templateUrl: "./spmt10321-confirm-dialog.component.html",
  styleUrls: ["./spmt10321-confirm-dialog.component.css"],
})
export class Spmt10321ConfirmDialogComponent implements OnInit, AfterViewInit {
  columnIds: string[] = [
    ColumnIds.SlipNo,
    ColumnIds.StoreCd,
    ColumnIds.StoreNm,
    ColumnIds.DisposalDate,
    ColumnIds.ReqStatusNm,
    ColumnIds.RedBlackNm,
    ColumnIds.SlipCancelNm,
    ColumnIds.DtQtyTotal,
    ColumnIds.CostAmtExcTotal,
    ColumnIds.SellPriceAmtExcTotal,
    ColumnIds.SlipCreateDate,
    ColumnIds.SlipApproveDate,
    ColumnIds.SlipChangeDate,
    ColumnIds.SlipCancelDate,
    ColumnIds.RequesterCd,
    ColumnIds.ApproverCd,
    ColumnIds.SlipComment,
    ColumnIds.ApproverComment,
  ];

  columnDefs: TableColumnDef[] = [
    { columnId: ColumnIds.SlipNo, header: ColumnHeaders.SlipNo, width: 90, align: Alginment.Left, editable: true },
    { columnId: ColumnIds.StoreCd, header: ColumnHeaders.StoreCd, width: 70, align: Alginment.Left },
    { columnId: ColumnIds.StoreNm, header: ColumnHeaders.StoreNm, width: 110, align: Alginment.Left },
    { columnId: ColumnIds.DisposalDate, header: ColumnHeaders.DisposalDate, width: 75, align: Alginment.Left },
    { columnId: ColumnIds.ReqStatusNm, header: ColumnHeaders.ReqStatusNm, width: 75, align: Alginment.Left },
    { columnId: ColumnIds.RedBlackNm, header: ColumnHeaders.RedBlackNm, width: 70, align: Alginment.Left },
    { columnId: ColumnIds.SlipCancelNm, header: ColumnHeaders.SlipCancelNm, width: 90, align: Alginment.Left },
    { columnId: ColumnIds.DtQtyTotal, header: ColumnHeaders.DtQtyTotal, width: 80, align: Alginment.Right, numberPipe: "1.0-0" },
    { columnId: ColumnIds.CostAmtExcTotal, header: ColumnHeaders.CostAmtExcTotal, width: 150, align: Alginment.Right, numberPipe: "1.0-0" },
    { columnId: ColumnIds.SellPriceAmtExcTotal, header: ColumnHeaders.SellPriceAmtExcTotal, width: 150, align: Alginment.Right, numberPipe: "1.0-0" },
    { columnId: ColumnIds.SlipCreateDate, header: ColumnHeaders.SlipCreateDate, width: 80, align: Alginment.Left },
    { columnId: ColumnIds.SlipApproveDate, header: ColumnHeaders.SlipApproveDate, width: 80, align: Alginment.Left },
    { columnId: ColumnIds.SlipChangeDate, header: ColumnHeaders.SlipChangeDate, width: 80, align: Alginment.Left },
    { columnId: ColumnIds.SlipCancelDate, header: ColumnHeaders.SlipCancelDate, width: 80, align: Alginment.Left },
    { columnId: ColumnIds.RequesterCd, header: ColumnHeaders.RequesterCd, width: 110, align: Alginment.Left },
    { columnId: ColumnIds.ApproverCd, header: ColumnHeaders.ApproverCd, width: 110, align: Alginment.Left },
    { columnId: ColumnIds.SlipComment, header: ColumnHeaders.SlipComment, width: 190, align: Alginment.Left },
    { columnId: ColumnIds.ApproverComment, header: ColumnHeaders.ApproverComment, width: 190, align: Alginment.Left, isTextbox: true },
  ];

  dataSource: MatTableDataSource<TableRow> = new MatTableDataSource<TableRow>([]);
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  title: string = "";
  titleNotification: string = "";
  public itemTableWidth: any;
  constructor(
    public dialogRef: MatDialogRef<Spmt10321ConfirmDialogComponent>,

    public httpBasic: HttpBasicService,
    @Inject(MAT_DIALOG_DATA) public data: { rows: Spmt10321ConfirmRowDto[]; confirmKbn: string; access: ReqAccess },
    private readonly message: MessageService,
    public commonService: CommonService
  ) {
    this.title = this.data.confirmKbn === GC_D2087_APPROVED ? "廃棄申請承認" : "廃棄申請却下";
    this.titleNotification = this.data.confirmKbn === GC_D2087_APPROVED ? "廃棄・経費振替承認" : "廃棄・経費振替却下";
  }

  ngOnInit() {
    this.calcTableWidth();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.data = this.data.rows.map((item) => ({ ...item, form: { approverCommentFormCtrl: new FormControl(item.approverComment ?? EMPTY_STRING) } }));
  }

  calcTableWidth() {
    this.itemTableWidth = { width: "100%" };
  }

  btnConfirmClick() {
    this.commonService.openYesNoDialog(this.titleNotification, this.message.message[MQ200003]).subscribe((data) => {
      if (data) this.fnConfirm();
    });
  }

  fnConfirm() {
    this.httpBasic.beforeRequestStart(LoadingMessages.Registing);
    const request: ReqSpmt10321Confirm = {
      rows: this.dataSource.data.map((item) => ({ ...item, approverComment: item.form.approverCommentFormCtrl.value, form: undefined })),
      access: this.data.access,
      confirmKbn: this.data.confirmKbn,
    };
    this.httpBasic.spmt10321Confirm(request).subscribe({
      next: (res) => {
        if (this.httpBasic.handleAppError(res)) return;
        const dialogRef = this.commonService.dialog.open(NotificationDialogComponent, {
          data: { title: this.title, message: this.message.message[MI200002] },
        });
        dialogRef.afterClosed().subscribe(() => {
          this.dialogRef.close({ isClose: true });
        });
      },
      error: (err) => {
        this.httpBasic.afterRequestError(err);
      },
      complete: () => {
        this.httpBasic.afterRequestComplete();
      },
    });
  }
}
